import React from 'react';
import { ORDER_STATUS, sortArray } from 'utils';

const OrderStatusDropdown = props => {
  const getOptions = () => {
    const keys = Object.keys(ORDER_STATUS);
    return sortArray(keys).map((key, i) =>
      <option key={i} value={ORDER_STATUS[key]}>{ORDER_STATUS[key]}</option>,
    );
  };

  return (
    <div>
      <select value={props.value} onChange={e => props.onSelect(e.target.value)}className={'form-control'}>
        <option hidden={!!props.value} value={'default'}>Select a status</option>
        {getOptions()}
      </select>
    </div>
  );
};

export default OrderStatusDropdown;